<div class="error-container">
  <div class="background-decoration">
    <div class="floating-shape shape-1"></div>
    <div class="floating-shape shape-2"></div>
    <div class="floating-shape shape-3"></div>
  </div>
  
  <div class="error-content">
    <div class="error-icon">
      <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="60" cy="60" r="60" fill="url(#gradient)"/>
        <path d="M60 20L60 70M60 80L60 90" stroke="white" stroke-width="6" stroke-linecap="round"/>
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#ff6565"/>
            <stop offset="100%" style="stop-color:#940707"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
    
    <div class="error-number">
      <span class="digit">4</span>
      <span class="digit">0</span>
      <span class="digit">4</span>
    </div>
    
    <h1>Página não encontrada</h1>
    <p>Ops! A página que você está procurando não existe ou foi movida para outro local.</p>
    
    <div class="actions">
      <button class="btn-primary" routerLink="/">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
        </svg>
        Voltar para início
      </button>
      <button class="btn-secondary" (click)="voltar()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"/>
        </svg>
        Voltar página anterior
      </button>
    </div>
  </div>
</div>